export default {
  colors: {
    background: '#0f5562',
    darkGreen: '#30a35d',
    lightGreen: '#bee567',
    orange: '#ff851c',
    green: '#69be28',
    white: '#fff',
  },
  map: {
    height: 680,
    smHeight: 330,
    width: 870,
  },
  personTypes: {
    1: 'adult',
    2: 'teenager',
    3: 'kid',
  },
  width: 1200,
}
